import { call, put } from 'redux-saga/effects'
import TrackOrderActions from '../Redux/TrackOrderRedux'
import LoginActions from '../Redux/LoginRedux'
export function * trackOrder (api, {params}) {
  try {
    const res = yield call(api, params)
    if (res === 'Unauthorized') {
      yield put(LoginActions.loginFailure())
      return
    }
    if (res.data) { 
      yield put(TrackOrderActions.trackOrderSuccess(res.data)) 
    } else {
      yield put(TrackOrderActions.trackOrderFailure(res))
    }
  } catch (error) {
    yield put(TrackOrderActions.trackOrderFailure(error.message))
  }
}
